function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI-letter",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "29-desktop-UI-letter",
  transform: "translate(-381.000000, -807.000000)",
  fillRule: "nonzero",
  strokeWidth: 2.20000005
}, React.createElement("g", {
  id: "iconamail-letter",
  transform: "translate(383.000000, 808.000000)"
}, React.createElement("polyline", {
  id: "Triangle-5-letter",
  stroke: "#3F5063",
  transform: "translate(26.500000, 21.500000) scale(1, -1) translate(-26.500000, -21.500000) ",
  points: "12.8066479 25 0 18 53 18 43.5643395 22.8295341"
}), React.createElement("g", {
  id: "Group-18-letter",
  transform: "translate(10.000000, 0.000000)",
  stroke: "#6EC18A"
}, React.createElement("g", {
  id: "Group-17-letter"
}, React.createElement("g", {
  id: "Group-letter",
  transform: "translate(18.500000, 15.500000) rotate(12.000000) translate(-18.500000, -15.500000) translate(3.000000, 3.000000)"
}, React.createElement("polyline", {
  id: "Rectangle-49",
  points: "0.739282438 24.4810955 0.739282438 0.019745204 30.6059498 0.019745204 30.6059498 18.204821"
}), React.createElement("path", {
  d: "M6.0666668,7.68035731 L16.3333337,7.68035731",
  id: "Line-letter"
}), React.createElement("path", {
  d: "M6.0666668,16.7160718 L26.1333339,16.7160718",
  id: "Line-Copy-letter"
}), React.createElement("path", {
  d: "M6.0666668,21.0080362 L20.237305,21.0080362",
  id: "Line-Copy-2-letter"
})))), React.createElement("polygon", {
  id: "Rectangle-48-letter",
  stroke: "#3F5063",
  points: "0 25 53 25 53 53 0 53"
}), React.createElement("path", {
  d: "M32,41 L46.375,49.5",
  id: "Line-letter",
  stroke: "#3F5063"
}), React.createElement("path", {
  d: "M19,41 L5,50 L19,41 Z",
  id: "Line-Copy-letter",
  stroke: "#3F5063",
  fill: "#D8D8D8"
}))));

var SvgLetter = function SvgLetter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "57px",
    height: "56px",
    viewBox: "0 0 57 56",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLetter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/letter.f145d008.svg";
export { ForwardRef as ReactComponent };